/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
// import * as serviceWorker from './serviceWorker';

// local imports
import AuthProvider from './contexts/AuthContext';
import ThemeProvider from './contexts/ThemeContext';

// if (!window.location.host.startsWith("www")){
//   window.location = window.location.protocol + "//" + "www." + window.location.host + window.location.pathname;
// }

// axios interceptor for logout on unauthorized access
// axios.interceptors.response.use(response => {
//   return response;
// }, error => {
//   // console.log('interceptor error ->>>> ', error);
//   if (error.response.status === 401) {
//     console.log("error 401");
//     // const { setUser, setIsAuthenticated } = useContext(AuthContext);
//     // setUser({ username: "", email: "", profileImage: "", timezone: "", selectedRole: "", roles: [], guideTakenFor: [], isApproved: false });
//     // setIsAuthenticated(false);
//   }
//   return Promise.reject(error);
// });

ReactDOM.render(
  <React.StrictMode>
    <AuthProvider>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </AuthProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
// serviceWorker.register();